export default __webpack_public_path__ + "static/media/flow.45f14799.png";